import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./conciliar-conta-listar/conciliar-conta-listar.module').then(m => m.ConciliarContaListarModule) }
  ])],
  exports: [RouterModule]
})
export class ConciliarContaRoutingModule { }
